import { useClientStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import errorMessages from 'constants/errorMessages'
import type { RouteMeta } from 'vue-router'

export const useSubscription = () => {
	const {
		subscriptions,
		subscriptionPerks,
	} = storeToRefs(useClientStore())

	function checkIfSubscribedTo(component: string) {
		const subscriptionItem = subscriptions.value
			?.flatMap((subscription) => [
				...subscription.subscriptionModules,
				...subscription.subscriptionMethods,
			])
			.find((element) => element.name === component)

		let allowed = false
		let reason = ''

		if (subscriptionItem) {
			allowed = true
		}

		return {
			// subscription,
			allowed,
			reason,
		}
	}

	/**
	 * Gemeinsame Abo-Sperre einer Route (`meta.subs`, alle Einträge nötig): Drawer, AdminMenu,
	 * BuildingNav, widgetLinks und der Router-Guard subscriptionGuard nutzen dieselbe Prüfung (AAR-1984 M1).
	 */
	function isRouteLocked(route?: { meta?: RouteMeta } | null) {
		const subs = route?.meta?.subs
		if (!Array.isArray(subs) || subs.length === 0) return false
		return !subs.every((sub) => checkIfSubscribedTo(sub).allowed)
	}

	return {
		subscriptions,
		subscriptionPerks,
		checkIfSubscribedTo,
		isRouteLocked,
	}
}
